// extracted by mini-css-extract-plugin
module.exports = {"DashboardWrapper":"Dashboard_DashboardWrapper__Ce8n3","heading":"Dashboard_heading__3Kuxt"};